<template>
	<div :class="displayStore.isDesktop ? 'search_box' : 'search_box_mobile'">
		<CloseIcon class="cursor-pointer" @click="onClickSearchBtn" /><InputSearch
			:model-value="searchValue"
			:placeholder="PLACEHOLDER_SEARCH_TITLE"
			:is-left="true"
			@update:model-value="onInputSearch"
		/>
		<SearchDropDown
			v-if="searchValue.length !== 0"
			:data="eventSearchData?.search_result ?? []"
			@close="onClickInputItem"
		/>
	</div>
</template>
<script setup lang="ts">
// core
import { computed, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
// lib
import { debounce } from 'lodash';

// api
import { useGetEventSearchApi } from '@/api/event';
// asset
import CloseIcon from '@/assets/img/common/clear.svg?component';
// component
import SearchDropDown from '@/components/atom/dropdown/SearchDropDown.vue';
// constant
import { PLACEHOLDER_SEARCH_TITLE } from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';
// util
import { closeMenuModal, openMenuModal } from '@/utils/function/modalMenu';

// -----variable-----
const displayStore = useDisplayStore();
const route = useRoute();

const searchValue = ref('');
const { data: eventSearchData } = useGetEventSearchApi(
	computed(() => ({ search: searchValue.value })),
	computed(() => !!searchValue.value)
);

// -----function-----
// 검색 창 유무
const onInputSearch = debounce(
	async (val: string) => {
		searchValue.value = val;
	},
	200,
	{ leading: false }
);
// 닫기 버트 클릭 시, 검색 창 닫힘 및 search 모달 오픈
const onClickSearchBtn = () => {
	if (route.query.isSearchMenuOpen) {
		closeMenuModal();
	} else {
		openMenuModal({ menu: 'Search' });
	}
};
// 드롭다운 아이템 클릭 시 input 값 변경
const onClickInputItem = () => {
	searchValue.value = '';
};

onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style lang="scss" scoped>
.btn_search {
	position: relative;
	.search_box {
		position: absolute;
		z-index: 85;
		background-color: var(--color-bg);
		top: 7rem;
		right: -15rem;
		display: flex;
		flex-direction: column;
		width: 37.5rem;
		border-radius: var(--border-radius-small);
		align-items: flex-end;
		gap: 1rem;
		padding: 1.6rem 2rem;
	}
	.search_box_mobile {
		position: absolute;
		z-index: 85;
		background-color: var(--color-bg);
		top: 7rem;
		right: -5.5rem;
		display: flex;
		flex-direction: column;
		width: 37.5rem;
		border-radius: var(--border-radius-small);
		align-items: flex-end;
		gap: 1rem;
		padding: 1.6rem 2rem;
	}
}
</style>
